export const REQUEST_ERROR = 'RequestError';
export const RESPONSE_ERROR = 'ResponseError';
export const BACKEND_500_ERROR = 'Backend500Error';
export const ABORT_ERROR = 'AbortError';
